import { useState } from "react";
import "./APIExcipients.css";
import Breadcrumb from "../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";

const Services = () => {


  const polypropyleneProducts = [
    {
      id: 1,
      name: "ACETICACID",
      image: "/assets/img/api-excipients/aceticacid.png",
      usage: [
        {
          title: "FOOD INDUSTRY",
          points: [
            "Used as a preservative, flavoring agent, and acidulant in food products.",
            "A key component of vinegar, widely used in cooking, pickling, and as a condiment.",
            "Helps balance pH in various food items."
          ],
        },
        {
          title: "CHEMICAL INDUSTRY",
          points: [
            "Crucial raw material in the production of acetic anhydride, acetate esters, coatings, solvents, and plastics.",
            "Widely used in chemical manufacturing processes."
          ],
        },
        {
          title: "PHARMACEUTICALS",
          points: [
            "Used as a solvent in the production of medications.",
            "Applied in medical treatments for ear infections and as a topical antiseptic."
          ],
        },
        {
          title: "COSMETICS AND PERSONAL CARE",
          points: [
            "Used in hair care products like shampoos and conditioners for pH balance.",
            "Acts as an exfoliant in skin care products, helping improve texture."
          ],
        },
        {
          title: "AGRICULTURE",
          points: [
            "Sometimes used in herbicides for effective weed control.",
            "Acts as a pH regulator in agricultural solutions and formulations."
          ],
        },
        {
          title: "CLEANING PRODUCTS",
          points: [
            "Commonly used in household cleaners due to antibacterial and acidics properties.",
            "Helps dissolve mineral deposits, lime scale, and soap scum."
          ],
        },
      ],
    },

    {
      id: 2,
      name: "AMOXICILLINTRIHYDRATE(COMACTED)",
      image: "/assets/img/api-excipients/alphacypermethrin.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: ["Tablets and Capsules The compacted form is specifically designed for direct compression in tablet manufacturing",
            "Improves production efficiency by enhancing flowability and reducing dusts formation",
            "Suspensions Utilized in oral liquid formulations for pediatric and geriatric patients",
            "Effective againsts bacterial infections, including respiratory tract infections, urinary tract infections, and skin infections.",
          ],
        },
        {
          title: "Veterinary Medicine", 
          points: ["Oral Dosage Forms Used in formulations for treating bacterial infections in animals, particularly in oral dosage forms.",
            "Oral powders",
            "Suspensions",
            "Bolus tablets",
            "Premixes",
          ],
        },
        {
          title: "Manufacturing & Handling Benefits",
          points: ["Enhanced flow properties make it suitable for high-speed automatic machines.",
            "Reduced dust helps maintain cleaner production areas and reduces material loss.",
            "Better compressibility, resulting in stronger tablets with fewer defects.",
            "Improves overall processing efficiency and reduces downtime.",
          ],
        },
      ],
    },


    {
      id: 3,
      name: "AMOXICILLINTRIHYDRATE(LIGHT)",
      image: "/assets/img/api-excipients/amoxicillintrihydrate (2).png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: ["Used in Tablet and Capsule Manufacturing The compacted grade is ideal for direct compression, improving tablet hardness and uniformity.",
            "Enhanced Flowability The compacted form provides excellent flow properties, making it suitable for high-speed tablet production.",
            "Reduced Dust Formation Minimizes dust during processing, improving operator safety and maintaining a cleaner production environment.",
            "Suitable for Oral Suspensions Commonly used in pediatric and geriatric liquid formulations due to its good dispersibility.",
            "Used in Combination Formulations Often formulated with clavulanic acid to combat beta-lactamase–producing bacteria.",
          ],
        },
        {
          title: "Veterinary Medicine",
          points: [
            "Widely used veterinary antibiotic effective against a broad range of Gram-positive and Gram-negative bacterial infections in animals.",
            "Suitable for multiple species including cattle, poultry, swine, sheep, goats, horses, dogs, and cats.",
            "Applicable in oral dosage forms such as veterinary suspensions, powders, bolus tablets, and premixes.",
            "High absorption and bioavailability ensuring fast therapeutic action and reliable outcomes in animals.",
            "Compacted grade provides improved particle flow, making it ideal for large-scale veterinary formulation processing."
          ],
        }

      ],
    },


    {
      id: 4,
      name: "ASCORBICACID",
      image: "/assets/img/api-excipients/ascorbicacid.png",
      usage: [
        {
          title: "Food and Beverage Industry",
          points: [
            "Preservative – Prevents oxidation and spoilage in processed foods and beverages.",
            "Antioxidant – Maintains color, flavor, and nutrients in juices, jams, and canned goods.",
            "Fortification – Adds nutritional value to cereals, snacks, and beverages.",
          ]
        },
        {
          title: "Pharmaceutical Industry",
          points: [
            "Dietary supplements – Used in tablets, capsules, and powders to prevent or treat vitamin C deficiency (scurvy).",
            "Therapeutic use – Supports immune function, aids in wound healing, and protects cells from oxidative stress.",
          ]
        },
        {
          title: "Cosmetic Industry",
          points: [
            "Skincare products – Used in creams, serums, and masks for antioxidant benefits and brightening skin tone.",
            "Anti-aging – Helps reduce fine lines and wrinkles by supporting collagen synthesis and improving skin elasticity.",
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Anti-browning agent – Prevents discoloration in fresh-cut fruits and vegetables.",
            "pH adjuster – Used to stabilize formulations in chemical and industrial processes.",
          ],
        },
      ],
    },

    {
      id: 5,
      name: "AZITHROMYCINDIHYDRATE",
      image: "/assets/img/api-excipients/azithromycindihydrate.png",
      usage: [
        {
          title: "PHARMACEUTICAL INDUSTRY",
          points: [
            "Antibiotic treatment used to treat bacterial infections such as pneumonia, bronchitis, ear infections, and sexually transmitted infections (STIs) like chlamydia and gonorrhea.",
            "Used in the treatment of infections associated with inflammatory conditions, as it also has mild anti-inflammatory effects.",
            "Employed in some cases as a preventive measure for infections, particularly in immunocompromised patients.",
          ],
        },
        {
          title: "VETERINARY USE",
          points: [
            "Used in veterinary medicine to treat bacterial infections in animals, particularly respiratory infections in livestock and pets.",
            "Helps treat skin and soft tissue infections in animals, especially dogs and cats.",
            "Often used for treating gastrointestinal infections caused by susceptible bacteria.",
            "Administered in poultry farming to control respiratory and systemic bacterial infections.",
          ],
        },
      ],
    },

    {
      id: 6,
      name: "CAFFEINEANHYDROUS",
      image: "/assets/img/api-excipients/caffeineanhydrous.png",
      usage: [
        {
          title: "PHARMACEUTICAL INDUSTRY",
          points: [
            "Used in stimulant drugs to combat fatigue and increase alertness.",
            "Commonly combined with aspirin or acetaminophen in pain relievers to enhance effectiveness.",
            "Included in respiratory treatments for conditions such as apnea in newborns.",
          ],
        },
        {
          title: "FOOD & BEVERAGE INDUSTRY",
          points: [
            "Widely used as a stimulant ingredient in energy drinks, soft drinks, and functional beverages.",
            "Added to dietary supplements to improve mental focus and reduce fatigue.",
            "Used in sports nutrition products to enhance physical performance and endurance.",
          ],
        },
        {
          title: "COSMETICS INDUSTRY",
          points: [
            "Used in anti-cellulite products to improve skin texture by promoting blood flow.",
            "Added to eye creams to reduce puffiness and dark circles by constricting blood vessels.",
            "Used in shampoos and hair care formulations to stimulate hair follicles and reduce hair loss.",
          ],
        },
      ],
    },



    {
      id: 7,
      name: "CETYLALCOHOL",
      image: "/assets/img/api-excipients/cetylalcohol.png",
      usage: [
        {
          title: "COSMETICS & PERSONAL CARE PRODUCTS",
          points: [
            "Used as an emollient, emulsifier, and thickening agent in creams, lotions, shampoos, and conditioners to enhance texture and stability.",
            "Acts as a product stability enhancer, imparting a smooth and luxurious texture to formulations.",
          ],
        },
        {
          title: "PHARMACEUTICALS",
          points: [
            "Used as a stabilizer and thickener in ointments, creams, and topical medications to improve consistency and efficacy.",
            "Helps enhance formulation consistency for effective delivery of active ingredients.",
          ],
        },
        {
          title: "INDUSTRIAL USES",
          points: [
            "Used in the production of surfactants and detergents for cleaning and foaming applications.",
            "Functions as a lubricant in various industrial processes.",
          ],
        },
      ],
    },




    {
      id: 8,
      name: "CITRICACID(ANHYDROUS)",
      image: "/assets/img/api-excipients/citricacid.png",
      usage: [
        {
          title: "FOOD INDUSTRY",
          points: [
            "Used as a preservative, flavoring agent, and acidulant in various food products.",
            "Key component of vinegar substitutes and widely used in cooking, pickling, and as a condiment.",
            "Helps balance pH levels in food and enhances shelf life.",
          ],
        },
        {
          title: "CHEMICAL INDUSTRY",
          points: [
            "Used as a raw material in the production of acetic anhydride, acetate esters, solvents, coatings, and plastics.",
            "Important for manufacturing buffering agents and industrial chemical formulations.",
          ],
        },
        {
          title: "PHARMACEUTICALS",
          points: [
            "Used as a solvent in medication production and pharmaceutical formulations.",
            "Applied in medical treatments such as ear infection solutions and topical antiseptics.",
          ],
        },
        {
          title: "COSMETICS AND PERSONAL CARE",
          points: [
            "Used in shampoos and conditioners as a pH balancer.",
            "Included in skincare products as an exfoliant and for improving skin texture.",
          ],
        },
        {
          title: "AGRICULTURE",
          points: [
            "Sometimes used in herbicides for effective weed control.",
            "Acts as a pH regulator in various agricultural nutrient and spray solutions.",
          ],
        },
        {
          title: "CLEANING PRODUCTS",
          points: [
            "Used in household cleaners due to its antibacterial and acidic properties.",
            "Helps dissolve mineral deposits, lime scale, rust stains, and soap scum.",
          ],
        },
      ],
    },



    {
      id: 9,
      name: "CITRICACIDS(ANHYDROUS)",
      image: "/assets/img/api-excipients/citricacids.png",
      usage: [
        {
          title: "VETERINARY MEDICINE",
          points: [
            "Used for treating respiratory infections in livestock such as cattle, swine, and poultry caused by pathogens like Pasteurella spp., Actinobacillus pleuropneumoniae, and Haemophilus spp.",
            "Effective in treating gastrointestinal infections in animals caused by bacteria such as E. coli and Salmonella.",
            "Helps manage skin infections in animals, including wounds and abscesses caused by bacterial pathogens.",
          ],
        },
        {
          title: "FISH FARMING (AQUACULTURE)",
          points: [
            "Used to treat bacterial infections in fish caused by pathogens like Vibrio spp. and Aeromonas spp.",
            "Helps reduce fish mortality and prevents spread of bacterial diseases in aquaculture systems.",
          ],
        },
        {
          title: "PROPHYLACTIC USE IN LIVESTOCK",
          points: [
            "Used as a preventive treatment for bacterial infections in high-risk livestock populations.",
            "Administered after surgeries or stressful conditions to reduce the chance of bacterial outbreaks.",
          ],
        },
      ],
    },



    {
      id: 10,
      name: "DPANTHENOL",
      image: "/assets/img/api-excipients/dpanthenol.png",
      usage: [
        {
          title: "COSMETICS & PERSONAL CARE PRODUCTS",
          points: [
            "Acts as a moisturizer that improves skin hydration and reduces dryness.",
            "Helps in healing minor wounds and soothing irritated or sensitive skin.",
            "Reduces redness and inflammation, making it ideal for acne-prone or sensitive skin.",
            "Strengthens hair by improving elasticity and moisture retention.",
            "Adds shine, softness, and volume to hair while preventing breakage and split ends.",
            "Improves nail strength, flexibility, and prevents brittleness."
          ],
        },
        {
          title: "PHARMACEUTICALS",
          points: [
            "Promotes skin cell regeneration and accelerates wound and burn healing.",
            "Used in ointments and creams for treating cuts, scrapes, and minor burns.",
            "Helps in treating eczema, dermatitis, and other inflammatory skin conditions.",
            "Commonly used in diaper rash and sunburn relief formulations."
          ],
        },
        {
          title: "INDUSTRIAL USES",
          points: [
            "Used in animal feed to improve coat and skin health of livestock.",
            "Enhances immune response in animals as part of nutritional supplements.",
            "Added to foods and beverages for nutrient enrichment.",
            "Incorporated in pharmaceutical syrups and tablets to boost overall health and energy."
          ],
        },
      ],
    },




    {
      id: 11,
      name: "FOLICACID(INJECTION GRADE)",
      image: "/assets/img/api-excipients/folicacid.png",
      usage: [
        {
          title: "Treatment of Folic Acid Deficiency",
          points: [
            "Prevention and Treatment of Anemia: Stimulates production of healthy red blood cells to treat megaloblastic anemia caused by folate deficiency.",
            "Correction of Folic Acid Deficiency: Helps correct folate deficiencies, reducing symptoms such as fatigue, weakness, and irritability."
          ],
        },
        {
          title: "Pregnancy Support",
          points: [
            "Prevention of Neural Tube Defects: Crucial during pregnancy to prevent birth defects in the brain and spinal cord; recommended for women of childbearing age and early pregnancy.",
            "Support for Maternal Health: Aids in cell division and formation of the placenta, supporting overall maternal health."
          ],
        },
        {
          title: "General Health and Wellness",
          points: [
            "Cellular Function: Essential for DNA synthesis, cell division, and tissue growth, supporting healthy cellular functions.",
            "Cardiovascular Health: Can help lower homocysteine levels, reducing the risk of heart disease when used with other treatments."
          ],
        },
        {
          title: "Intravenous and Intramuscular Administration",
          points: [
            "Parenteral Formulation: Administered via IV or IM injection when oral supplementation is not feasible or higher doses are required for rapid correction of deficiency."
          ],
        }
      ],
    },




    {
      id: 12,
      name: "GLYCERIN",
      image: "/assets/img/api-excipients/glycerin.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Topical Applications: Used in creams, ointments, and lotions for moisturizing properties.",
            "Cough Syrups: Serves as a soothing agent.",
            "Suppositories: Acts as a laxative for bowel regulation.",
            "Capsules and Tablets: Works as a solvent or plasticizer."
          ],
        },
        {
          title: "Personal Care & Cosmetics",
          points: [
            "Moisturizers and Skincare Products: Prevents dryness by retaining moisture.",
            "Toothpaste: Helps maintain smooth texture and prevents drying out.",
            "Haircare Products: Adds moisture and shine to hair.",
            "Soap Manufacturing: Provides transparency and emollient properties."
          ],
        },
        {
          title: "Food & Beverage Industry",
          points: [
            "Sweetener: Used in sugar-free and low-sugar products.",
            "Preservative: Prevents moisture loss in food.",
            "Texturizer: Improves consistency in baked goods, candies, and dairy products."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Antifreeze: Used in automotive applications for its low freezing point.",
            "Plastic Manufacturing: Serves as a plasticizer.",
            "Explosives: Critical ingredient in nitroglycerin production.",
            "Paints and Coatings: Enhances flow and prevents cracking."
          ],
        },
        {
          title: "Health & Wellness",
          points: [
            "Vaping Liquids: Used as a base for e-cigarette liquids.",
            "Pet Care: Included in pet treats and medications.",
            "Herbal Extractions: Acts as a solvent in non-alcoholic tinctures."
          ],
        }
      ],
    },





    {
      id: 13,
      name: "IRBESARTAN",
      image: "/assets/img/api-excipients/irbesartan.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Tablets and Capsules: Formulated as monotherapy or in combination with other antihypertensive agents such as hydrochlorothiazide.",
            "Hypertension Management: Reduces the risk of cardiovascular events in patients with high blood pressure.",
            "Diabetic Nephropathy: Slows the progression of kidney disease in patients with type 2 diabetes and hypertension."
          ],
        }
      ],
    },



    {
      id: 14,
      name: "LEUCINE",
      image: "/assets/img/api-excipients/leucine.png",
      usage: [
        {
          title: "Muscle Growth and Recovery",
          points: [
            "Protein Synthesis and Muscle Protection: Stimulates muscle protein synthesis, promoting muscle growth and recovery after exercise.",
            "Prevents Muscle Breakdown: Helps prevent catabolism during fasting, intense exercise, or stress, protecting muscle tissue."
          ],
        },
        {
          title: "Nutritional Supplements",
          points: [
            "Support for Muscle Health: Part of the BCAAs (with isoleucine and valine), used in dietary supplements to enhance muscle health, endurance, and recovery.",
            "Clinical Nutrition: Used for patients with malnutrition, muscle wasting, or conditions requiring enhanced protein intake."
          ],
        },
        {
          title: "Medical Applications",
          points: [
            "Treatment and Recovery Aid: Helps manage conditions like cachexia in chronic illnesses such as cancer or AIDS by improving muscle mass and nutritional status.",
            "Support for Elderly and Post-Surgery Patients: Recommended to maintain muscle mass and improve recovery outcomes."
          ],
        }
      ],
    },


    {
      id: 15,
      name: "LIGHTLIQUIDPARAFFIN OIL",
      image: "/assets/img/api-excipients/lightliquidparaffinoil.png",
      usage: [
        {
          title: "Pharmaceutical and Cosmetic Industry",
          points: [
            "Sweetening Agent / Base for Ointments and Creams: Used as an emollient in topical formulations to soothe and protect the skin.",
            "Laxatives: Ingredient in medicinal formulations like liquid paraffin laxatives.",
            "Moisturizers: Incorporated into lotions and creams for hydrating properties.",
            "Hair Care Products: Used in hair oils, conditioners, and styling products for non-greasy lubrication."
          ],
        },
        {
          title: "Food and Beverage Industry (Food Grade)",
          points: [
            "Food-Grade Applications: Acts as a release agent, anti-sticking agent, or lubricant in food processing.",
            "Coating for Fruits and Vegetables: Applied as a thin layer to preserve freshness and gloss."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Lubricants: Serves as a lubricant in machinery where food-grade oils are required.",
            "Metalworking Fluids: Used in cutting, grinding, and machining processes as a cooling agent.",
            "Plastic and Polymer Industry: Functions as a plasticizer or mold release agent."
          ],
        },
        {
          title: "Chemical Synthesis and Industrial Processes",
          points: [
            "Carrier Fluid: Acts as a medium in chemical reactions requiring a stable, inert liquid.",
            "Diluent for Additives: Helps blend additives like dyes, pigments, and fragrances."
          ],
        },
        {
          title: "Textile and Leather Industry",
          points: [
            "Softener and Finishing Agent: Provides a smooth texture to fabrics and leather."
          ],
        },
        {
          title: "Agriculture",
          points: [
            "Pesticide Carrier: Used as a medium for formulating pesticides and herbicides."
          ],
        },
        {
          title: "Miscellaneous Uses",
          points: [
            "Candles and Polishes: Acts as a base in wax and polishing agents.",
            "Printing Inks: Enhances ink properties for specific industrial applications."
          ],
        }
      ],
    },





    {
      id: 16,
      name: "LIQUORICE(GLYCYRRHIZA)EXTRACT 10%",
      image: "/assets/img/api-excipients/LIQUORICE.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Anti-inflammatory and Antioxidant: Used in formulations for soothing sore throats, coughs, and other respiratory issues.",
            "Digestive Health: Treats indigestion, heartburn, and ulcers due to its anti-inflammatory and soothing properties.",
            "Skin Care: Incorporated in topical creams and ointments for anti-inflammatory and healing effects, especially for eczema, acne, and psoriasis."
          ],
        },
        {
          title: "Cosmetic Industry",
          points: [
            "Skin Whitening: Helps reduce pigmentation and even out skin tone in skincare products.",
            "Anti-aging: Provides antioxidant benefits in anti-aging formulations to combat free radicals and reduce fine lines and wrinkles."
          ],
        },
        {
          title: "Food and Beverage Industry",
          points: [
            "Flavoring Agent: Used in candies, beverages, and confectionery for its characteristic sweet taste.",
            "Herbal Supplements: Included in herbal supplements for soothing and digestive benefits."
          ],
        },
        {
          title: "Traditional Medicine",
          points: [
            "Cough and Cold Remedies: Used in herbal teas and syrups to treat coughs, colds, and sore throats."
          ],
        }
      ],
    },





    {
      id: 17,
      name: "LUTEIN10%",
      image: "/assets/img/api-excipients/lutein.png",
      usage: [
        {
          title: "Eye Health",
          points: [
            "Protection Against Macular Degeneration: Protects eyes from oxidative stress and helps prevent age-related macular degeneration (AMD) by filtering harmful blue light.",
            "Improved Visual Function: Regular supplementation is linked to better visual performance, especially in low-light conditions."
          ],
        },
        {
          title: "Skin Health",
          points: [
            "Antioxidant Protection: Helps protect skin from UV damage and oxidative stress, reducing visible signs of aging like wrinkles and fine lines.",
            "Hydration and Elasticity: Supports skin hydration and elasticity, contributing to a healthy, youthful appearance."
          ],
        },
        {
          title: "General Antioxidant Support",
          points: [
            "Free Radical Neutralization: Potent antioxidant that helps neutralize free radicals, supporting overall health and reducing risk of chronic diseases associated with oxidative stress."
          ],
        },
        {
          title: "Dietary Supplements",
          points: [
            "Vision and Skin Care Supplements: Commonly included in supplements aimed at promoting eye health, improving skin appearance, and providing antioxidant protection."
          ],
        }
      ],
    },




    {
      id: 18,
      name: "MAGNESIUMHYDROXIDEBP",
      image: "/assets/img/api-excipients/magnesiumhydroxide.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Antacid: Relieves heartburn, indigestion, and upset stomach by neutralizing excess stomach acid.",
            "Laxative: Acts as a gentle laxative by drawing water into the intestines to ease bowel movements."
          ],
        },
        {
          title: "Water Treatment",
          points: [
            "Neutralizing Agent: Used to neutralize acidic water and adjust pH levels.",
            "Wastewater Treatment: Applied in treating wastewater and removing heavy metals from industrial effluents."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Flame Retardant: Used in producing fire-resistant materials, particularly in plastics and rubber.",
            "Manufacturing of Chemicals: Employed in the production of other chemicals such as magnesium salts."
          ],
        },
        {
          title: "Cosmetic Industry",
          points: [
            "Skin Care Products: Added to some skincare formulations for its soothing and anti-inflammatory properties."
          ],
        }
      ],
    },




    {
      id: 19,
      name: "MAGNESIUMSULPHATE",
      image: "/assets/img/api-excipients/magnesiumsulphate.png",
      usage: [
        {
          title: "Agricultural Industry",
          points: [
            "Fertilizer: Provides magnesium and sulfur to promote healthy growth in crops like tomatoes, potatoes, and peppers.",
            "Soil Conditioner: Helps improve soil quality and nutrient content."
          ],
        },
        {
          title: "Pharmaceutical Industry",
          points: [
            "Magnesium Supplementation: Used in IV or oral formulations to treat magnesium deficiency.",
            "Eclampsia Treatment: Administered intravenously to control seizures in pregnant women with preeclampsia or eclampsia.",
            "Laxative: Acts as a mild laxative in certain medical treatments."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Manufacturing: Used in the production of textiles, paper, and various chemical processes.",
            "Water Treatment: Applied to remove impurities in water treatment processes."
          ],
        },
        {
          title: "Cosmetic Industry",
          points: [
            "Bath Soaks: Included in bath salts and body scrubs for soothing and muscle-relaxing properties."
          ],
        }
      ],
    },




    {
      id: 20,
      name: "MEBEVERINEHYDROCHLORIDE",
      image: "/assets/img/api-excipients/mebeverinehydrochloride.png",
      usage: [
        {
          title: "Treatment of Irritable Bowel Syndrome (IBS)",
          points: [
            "Relief of Abdominal Pain and Discomfort: Relieves symptoms of IBS including abdominal pain, bloating, and discomfort by relaxing smooth muscles of the intestines.",
            "Regulation of Bowel Movements: Reduces spasms that can lead to diarrhea or constipation, improving bowel function."
          ],
        },
        {
          title: "Gastrointestinal Disorders",
          points: [
            "Spasms in the Digestive Tract: Treats gastrointestinal disorders involving smooth muscle spasms, such as colitis or spastic colon.",
            "Post-Operative Bowel Recovery: Sometimes used after abdominal surgery to relieve bowel dysfunction caused by spasm."
          ],
        },
        {
          title: "Symptom Management in Other Digestive Disorders",
          points: [
            "Functional Digestive Disorders: Helps manage functional digestive disorders that cause discomfort, bloating, and irregular bowel movements, improving quality of life."
          ],
        }
      ],
    },


    {
      id: 21,
      name: "METFORMINHYDROCHLORIDE",
      image: "/assets/img/api-excipients/metforminhydrochloride.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Diabetes Treatment: Manages blood sugar levels in patients with type 2 diabetes without significantly increasing insulin secretion.",
            "Polycystic Ovary Syndrome (PCOS): Used off-label to improve insulin sensitivity and regulate menstrual cycles.",
            "Weight Management: May aid in weight loss in individuals with type 2 diabetes or obesity by improving insulin sensitivity and reducing appetite."
          ],
        },
        {
          title: "Veterinary Use",
          points: [
            "Animal Infections: Studied for potential use in managing insulin resistance in animals, particularly in horses and pets with obesity or metabolic disorders."
          ],
        }
      ],
    },




    {
      id: 22,
      name: "NICOTINAMIDE(INJECTION GRADE)",
      image: "/assets/img/api-excipients/nicotinamide.png",
      usage: [
        {
          title: "Medical and Therapeutic Use",
          points: [
            "Treatment of Pellagra: Restores normal metabolic function and alleviates symptoms of Vitamin B3 deficiency such as dermatitis, diarrhea, and dementia.",
            "Metabolic Disorders: Used to address various metabolic disorders related to nicotinic acid deficiency."
          ],
        },
        {
          title: "Skin Care and Dermatology",
          points: [
            "Topical Application: Used in dermatological treatments for acne, rosacea, and hyperpigmentation due to its anti-inflammatory properties.",
            "Anti-Aging and Skin Health: Included in injectable skin care treatments to promote skin repair, enhance barrier function, and reduce visible signs of aging."
          ],
        },
        {
          title: "Intravenous Formulations",
          points: [
            "Parenteral Nutrition: Included in IV nutrition formulations to provide essential nutrients to patients unable to consume food orally."
          ],
        }
      ],
    },

    {
      id: 23,
      name: "PARACETAMOLPOWDER",
      image: "/assets/img/api-excipients/paracetamolpowder.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Active Pharmaceutical Ingredient (API): Used as an API in analgesic and antipyretic medications."
          ],
        },
        {
          title: "Formulation Additives",
          points: [
            "Dosage Forms: Incorporated into tablets, capsules, syrups, and suspensions."
          ],
        },
        {
          title: "Industrial Use",
          points: [
            "Bulk Drug Production: Used in the large-scale production of pain relief and fever-reducing drugs."
          ],
        }
      ],
    },



    {
      id: 24,
      name: "POTASSIUMSORBATE",
      image: "/assets/img/api-excipients/potassiumsorbate.png",
      usage: [
        {
          title: "Food and Beverage Industry",
          points: [
            "Preservative: Used in cheeses, baked goods, dried fruits, syrups, pickles, and fruit juices to prevent growth of molds, yeasts, and bacteria, extending shelf life."
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Product Preservation: Acts as a preservative in lotions, shampoos, deodorants, and creams to prevent microbial contamination and maintain product safety and efficacy."
          ],
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Preservative in Medications: Ensures microbial stability and product integrity in pharmaceutical formulations."
          ],
        },
        {
          title: "Agriculture",
          points: [
            "Fungicide: Used in certain pesticides and plant growth products to prevent fungal growth."
          ],
        }
      ],
    },



    {
      id: 25,
      name: "PROPYLGALLATE",
      image: "/assets/img/api-excipients/propygallate.png",
      usage: [
        {
          title: "Food and Beverage Industry",
          points: [
            "Preservative and Flavor Enhancer: Used in oils, fats, processed foods, margarine, salad dressings, packaged snacks, processed meats, beverages, and confectionery to prevent rancidity and extend shelf life."
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Antioxidant and Preservative: Prevents oxidation of oils and active ingredients in creams, lotions, and shampoos, preserving efficacy and stability."
          ],
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Antioxidant and Preservative: Stabilizes formulations containing oils, such as oral suspensions and injectable drugs, preventing oxidative degradation and maintaining shelf life."
          ],
        }
      ],
    },




    {
      id: 26,
      name: "SODIUMBENZOATE",
      image: "/assets/img/api-excipients/sodiumbenzoate.png",
      usage: [
        {
          title: "Food and Beverage Industry",
          points: [
            "Preservative: Used in soft drinks, fruit juices, pickles, sauces, jams, and salad dressings to prevent growth of harmful bacteria, yeast, and molds."
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Product Preservation: Maintains safety and efficacy in shampoos, lotions, deodorants, and creams by preventing microbial contamination."
          ],
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Preservative in Medications: Used in syrups and liquid medications to prevent microbial growth and extend shelf life; also serves as an excipient in some drugs."
          ],
        }
      ],
    },



    {
      id: 27,
      name: "SODIUMLAURYLETHERSULFATE70%",
      image: "/assets/img/api-excipients/sodium.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Stimulant Drugs: Used in medications to combat fatigue and increase alertness.",
            "Pain Relievers: Commonly combined with aspirin or acetaminophen to enhance effectiveness.",
            "Respiratory Treatments: Included in treatments for conditions like apnea in newborns.",
            "Medicated Shampoos and Cleansers: Used for its emulsifying and foaming properties.",
            "Drug Formulation Aid: Acts as a wetting and dispersing agent in drug formulations."
          ],
        },
        {
          title: "Food & Beverage Industry",
          points: [
            "Processing Aid and Emulsifier: Occasionally used in non-consumable applications, such as cleaning solutions for food processing equipment.",
            "Hygiene Support: Supports hygiene in food preparation setups."
          ],
        },
        {
          title: "Cosmetics Industry",
          points: [
            "Anti-cellulite Products: Improves skin texture by promoting blood flow.",
            "Eye Creams: Reduces puffiness and dark circles by constricting blood vessels.",
            "Shampoos and Hair Care: Stimulates hair follicles and reduces hair loss."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Cleaning Agents: Used in industrial detergents and degreasers due to its surfactant properties.",
            "Textile and Leather Industry: Utilized for wetting and scouring processes."
          ],
        },
        {
          title: "Personal Care Products",
          points: [
            "Shampoos, Body Washes, and Liquid Soaps: Essential for manufacturing these products.",
            "Cleansing Agent: Provides rich lather and effective cleansing while being cost-efficient."
          ],
        }
      ],
    },




    {
      id: 28,
      name: "SULPIRIDE",
      image: "/assets/img/api-excipients/sulpiride.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Antipsychotic Treatment: Administered to animals for treating bacterial infections in livestock and pets.",
            "Antidepressant: Sometimes prescribed for depression, particularly in patients unresponsive to other medications.",
            "Gastrointestinal Disorders: Used as a prokinetic agent to treat dyspepsia and irritable bowel syndrome (IBS)."
          ],
        },
        {
          title: "Other Uses",
          points: [
            "Anxiolytic: Used in some cases to treat anxiety disorders."
          ],
        }
      ],
    },




    {
      id: 29,
      name: "VITAMINAPALMITATE",
      image: "/assets/img/api-excipients/vitaminapalmitate.png",
      usage: [
        {
          title: "Vision Health",
          points: [
            "Prevention of Night Blindness: Essential for rhodopsin formation in the retina, supporting low-light vision and overall eye health.",
            "Macular Health: Maintains macula health, reducing the risk of age-related macular degeneration (AMD)."
          ],
        },
        {
          title: "Immune System Support",
          points: [
            "Boosting Immunity: Enhances immune function by supporting white blood cell production and activity.",
            "Skin and Mucosal Integrity: Maintains integrity of skin and mucosal barriers, the body’s first line of defense against pathogens."
          ],
        },
        {
          title: "Skin Health",
          points: [
            "Skin Cell Growth: Regulates skin cell growth and differentiation, preventing dry, flaky skin.",
            "Anti-Aging: Retinoids derived from Vitamin A promote collagen production and reduce the appearance of wrinkles and fine lines."
          ],
        },
        {
          title: "Dietary Supplements",
          points: [
            "Fortification of Foods: Used to fortify dairy products, cereals, and baby foods to prevent Vitamin A deficiency.",
            "Oral Supplements: Included in dietary supplements to improve overall health, support vision, and boost immunity."
          ],
        }
      ],
    },


    {
      id: 30,
      name: "VITAMIND3",
      image: "/assets/img/api-excipients/vitamin.png",
      usage: [
        {
          title: "Bone Health",
          points: [
            "Calcium Absorption: Promotes absorption of calcium and phosphorus in the intestines, essential for strong bones and teeth; helps prevent rickets and osteomalacia.",
            "Bone Density: Helps maintain bone density and reduce fracture risk, especially in older adults."
          ],
        },
        {
          title: "Immune System Support",
          points: [
            "Immune Function: Modulates the immune system, enhancing pathogen-fighting effects of immune cells and reducing inflammation.",
            "Protection Against Infections: Reduces the risk of respiratory infections such as flu and common cold."
          ],
        },
        {
          title: "Mood and Mental Health",
          points: [
            "Mood Regulation: Influences mood regulation and may help manage depression, particularly seasonal affective disorder (SAD).",
            "Cognitive Function: Adequate levels are linked to improved cognitive function and reduced risk of cognitive decline in older adults."
          ],
        },
        {
          title: "Dietary Supplementation",
          points: [
            "Fortification of Foods: Used to fortify milk, cereals, and plant-based alternatives to prevent Vitamin D deficiency.",
            "Oral Supplements: Used in concentrated forms for individuals with low Vitamin D levels or limited sun exposure."
          ],
        },
        {
          title: "Support for Healthy Pregnancy",
          points: [
            "Pregnancy Health: Essential for maternal and fetal health, supports fetal bone development, and helps prevent complications such as preeclampsia."
          ],
        }
      ],
    },

    {
      id: 31,
      name: "ALPHA-CYPERMETHRIN",
      image: "/assets/img/api-excipients/ALPHACYPERMETHRIN.png",
      usage: [
        {
          title: "Agricultural Applications",
          points: [
            "Insect Control: Highly effective pyrethroid pesticide used to control a wide range of agricultural pests including bollworms, aphids, jassids, whiteflies, and caterpillars.",
            "Crop Protection: Commonly used on cotton, vegetables, fruits, cereals, and oilseed crops to reduce pest damage and increase crop yield.",
            "Low Application Rate: Provides strong insecticidal action even at low doses, making it cost-effective for farmers."
          ],
        },
        {
          title: "Public Health Applications",
          points: [
            "Mosquito Control: Used in vector control programs to reduce mosquito populations responsible for malaria, dengue, and chikungunya.",
            "Indoor Residual Spraying (IRS): Applied on interior walls for long-lasting control of mosquitoes and other vectors.",
            "Outdoor Fogging: Used in fogging operations to manage mosquito outbreaks in public areas."
          ],
        },
        {
          title: "Veterinary Use",
          points: [
            "Livestock Protection: Helps control ticks, lice, mites, and flies on cattle, sheep, goats, and poultry.",
            "Animal Housing Treatment: Used to disinfect barns, sheds, and poultry houses against crawling and flying insects."
          ],
        },
        {
          title: "Household and Industrial Applications",
          points: [
            "Household Pest Control: Used in sprays, coils, mats, and liquid vaporizer formulations to kill cockroaches, ants, flies, and mosquitoes.",
            "Termite and Wood Borer Protection: Added to wood-preserving chemicals to prevent wood-damaging insects.",
            "Industrial Fumigation: Used in warehouses, food storage facilities, and factories for pest management."
          ],
        },
        {
          title: "Mode of Action & Benefits",
          points: [
            "Mode of Action: Acts on the insect nervous system, causing paralysis and death by interfering with sodium channel function.",
            "Fast Knockdown: Provides quick action against insects with strong residual effects.",
            "Stability: Resistant to light degradation compared to other insecticides, making it suitable for outdoor use."
          ],
        }
      ],
    },

    {
      id: 32,
      name: "DELTAMETHRIN",
      image: "/assets/img/api-excipients/DELTAMETHRIN.png",
      usage: [
        {
          title: "Agricultural Applications",
          points: [
            "Broad-Spectrum Pest Control: Effective against a wide range of insects including bollworms, aphids, jassids, whiteflies, beetles, and caterpillars.",
            "Crop Protection: Commonly used on cotton, vegetables, fruits, cereals, pulses, and oilseeds to prevent yield loss.",
            "Low Dose Effectiveness: Highly potent pyrethroid insecticide that works effectively even at low application rates."
          ],
        },
        {
          title: "Public Health Applications",
          points: [
            "Mosquito Control: Widely used in malaria, dengue, chikungunya, and Zika vector control programs.",
            "Indoor Residual Spraying (IRS): Applied on walls and surfaces to provide long-term mosquito and vector control.",
            "Space Spraying: Used for fogging operations in public areas to reduce mosquito populations during outbreaks."
          ],
        },
        {
          title: "Veterinary and Livestock Use",
          points: [
            "Ectoparasite Control: Helps control ticks, lice, flies, and mites on livestock animals such as cattle, goats, sheep, and poultry.",
            "Housing Treatment: Used for disinfecting and treating barns, stables, and poultry sheds to eliminate insects."
          ],
        },
        {
          title: "Household and Industrial Applications",
          points: [
            "Household Pest Control: Used in insecticide sprays, coils, vaporizers, and powders to control cockroaches, ants, mosquitoes, and flies.",
            "Stored Grain Protection: Effective in warehouses and storage units to protect grains from beetles and moth infestations.",
            "Wood & Material Protection: Used in treatments to prevent damage from termites and wood-boring insects."
          ],
        },
        {
          title: "Mode of Action & Benefits",
          points: [
            "Mode of Action: Acts on insect nerve cells by disrupting sodium channel function, causing paralysis and death.",
            "Fast Knockdown: Provides quick and powerful insect control with long residual activity.",
            "UV Stability: More stable in sunlight compared to many other insecticides, making it ideal for outdoor use."
          ],
        }
      ],
    },



  ];




  const defaultImage =
    "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

  const [selectedProduct, setSelectedProduct] = useState(null);
  const closeModal = () => setSelectedProduct(null);
  return (
    <>
      <Breadcrumb
        title="Chemicals"
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      />

      <section className="pp-section">
        <div className="container">
          <h2 className="heading01 text-center mb-5">Chemicals</h2>

          <div className="pp-grid">
            {polypropyleneProducts.map((product) => (
              <div className="pp-card" key={product.id}>
                <div className="pp-img-box">
                  <img
                    src={product.image || defaultImage}
                    alt={product.name}
                    onError={(e) => (e.target.src = defaultImage)}
                  />
                </div>
                <div className="pp-info">
                  <h2 className="pp-name">{product.name}</h2>
                  <button
                    className="view-btn"
                    onClick={() => setSelectedProduct(product)}
                  >
                    View Details <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {selectedProduct && (
            <div className="modal-overlay" onClick={closeModal}>
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={selectedProduct.image || defaultImage}
                  alt={selectedProduct.name}
                  className="modal-image"
                />
                <h2 className="modal-title">{selectedProduct.name}</h2>

                <div className="usage-section">
                  {selectedProduct.usage.map((section, index) => (
                    <div key={index} className="usage-block">
                      <h3>{section.title}</h3>
                      <ul>
                        {section.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>

                <button className="close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Services;
